import styled from 'styled-components';

export const Box = styled.div`
  margin-top: 24px;

  .ant-tabs-nav-list {
    padding: 1rem;
  }
`;
